import React, { useEffect } from "react";
import { ActivitySpecialFormStyled } from "./styled";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MdDelete } from "react-icons/md";
import QuestionForm from "./QuestionForm";
import { toast } from "react-toastify";
import moment from "moment";
import { AlertControl } from "components/Modals/Alert";
import { Buttons, Inputs } from "components";

const ActivitySpecialForm = ({
  id,
  initialValues,
  pdpaOptions,
  businessUnitOptions,
  permission,
  onCancel,
  onDelete,
  onDeleteQuestion,
  onSent,
  onSubmit,
  onDuplicate,
}) => {
  const schema = yup.object().shape({
    type: yup.string().required("Activity type is required"),
    code: yup.string().required("Activity Code is required"),
    short_title_en: yup.string().required("Activity name is required"),
    short_title_th: yup.string().required("Activity name is required"),
    short_description_en: yup.string().required("Activity name is required"),
    short_description_th: yup.string().required("Activity name is required"),
    name_en: yup.string().required("Activity name is required"),
    name_th: yup.string().required("Activity name is required"),
    description_en: yup.string().required("Description is required"),
    description_th: yup.string().required("Description is required"),
    // point: yup.string().required("Point name is required"),
    // permission_type: yup.string().required("Required"),
    registration_start_date: yup.string().required("Required"),
    registration_end_date: yup.string().required("Required"),
    // announcement_date: yup.string().required("Required"),
    // qrcode_amount: yup.string().required('Qrcode amount is required'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "question_list",
  });

  const watchIsCondition = watch("is_condition");
  const watchQuestionList = watch("question_list");

  useEffect(() => {
    if (initialValues) {
      let params = {
        ...initialValues,
        business_unit_ref_id: initialValues.business_unit_ref_id
          ? initialValues.business_unit_ref_id
          : "null",
        start_date:
          initialValues.start_date && new Date(initialValues.start_date),
        end_date: initialValues.end_date && new Date(initialValues.end_date),
        img_file: initialValues.img ? [{ media_uri: initialValues.img }] : [],
        img_file2: initialValues.img2
          ? [{ media_uri: initialValues.img2 }]
          : [],
        document_file: initialValues.document
          ? [{ media_uri: initialValues.document }]
          : [],
      };
      if (initialValues.registration_start_time) {
        params.registration_start_time = new Date(
          moment(initialValues.registration_start_time, "HH:mm")
        );
      }
      if (initialValues.registration_end_time) {
        params.registration_end_time = new Date(
          moment(initialValues.registration_end_time, "HH:mm")
        );
      }
      if (initialValues.question_list) {
        params.question_list = initialValues.question_list.map((e) => ({
          ...e,
          questions:
            e?.questions &&
            e.questions.map((f) => ({
              ...f,
              image: f.img_path ? [{ media_uri: f.img_path }] : [],
            })),
        }));
      }
      reset({
        ...params,
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const _onSubmit = (values) => {
    let isError = false;
    if (!isError) {
      // Re-sync each part's `page` with its current position so that
      // adding/deleting/reordering parts always produces a sequential,
      // unique page number (react-hook-form's defaultValue is only applied
      // at registration time, so shifted parts keep their stale page value).
      const params = {
        ...values,
        question_list: values.question_list
          ? values.question_list.map((e, i) => ({ ...e, page: i + 1 }))
          : values.question_list,
      };
      onSubmit(params);
    } else {
      toast.error("กรุณากรอกเงื่อนไขให้ครบ");
    }
  };

  const _handleCopyUrl = async (key) => {
    try {
      switch (key) {
        case "member":
          await navigator.clipboard.writeText(
            `${process.env.REACT_APP_DOMAIN}?redirect=online-form&id=${initialValues._id}`
          );
          toast.success("คัดลอกข้อความแล้ว!");
          break;
        case "no-member":
          await navigator.clipboard.writeText(
            `${process.env.REACT_APP_DOMAIN}/no-member/activity-form/${initialValues._id}/quiz/create/update`
          );
          toast.success("คัดลอกข้อความแล้ว!");
          break;
        default:
          break;
      }
    } catch (err) {
      toast.error("เกิดข้อผิดพลาดในการคัดลอก");
    }
  };

  return (
    <ActivitySpecialFormStyled>
      <form onSubmit={handleSubmit(_onSubmit)}>
        {id === "create" ? (
          <div className="duplicate_wrap">
            <div className="duplicate_btn">
              <Buttons.BgStandard
                type="button"
                label="Duplicate Online Form"
                onClick={onDuplicate}
              />
            </div>
          </div>
        ) : (
          <div className="duplicate_wrap">
            <div className="duplicate_btn">
              <Buttons.BgStandard
                type="button"
                label="Copy URL for Non-Member"
                onClick={() => _handleCopyUrl("no-member")}
              />
              <div className="btn_hint">
                (ยืนยันตัวตนด้วยบัญชีและ OTP แทนการ Login)
              </div>
            </div>
            <div className="duplicate_btn">
              <Buttons.BgStandard
                type="button"
                label="Copy URL"
                onClick={() => _handleCopyUrl("member")}
              />
              <div className="btn_hint">(ต้อง Login ด้วยบัญชีสมาชิกเท่านั้น)</div>
            </div>
          </div>
        )}
        <div className="f_title">Online Form</div>
        <div className="input_row">
          <div className="f_left_col">Activity Type</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.Dropdown
                  {...field}
                  options={[
                    {
                      label: "ฟอร์มสมัครแข่งพิเศษ สมัครได้หลายคน",
                      value: "1",
                    },
                  ]}
                  errors={errors.type?.message}
                  disabled={id !== "create"}
                />
              )}
              name="type"
              // defaultValue={{
              //   label: "ฟอร์มสมัครแข่งพิเศษ สมัครได้หลายคน",
              //   // value: "1",
              // }}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Business Unit</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.Dropdown {...field} options={businessUnitOptions} />
              )}
              name="business_unit_ref_id"
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Code</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField {...field} errors={errors.code?.message} />
              )}
              name="code"
              defaultValue=""
            />
          </div>
        </div>
        <div className="input_row lang_row">
          <div className="f_left_col">Short Title</div>
          <div className="f_right_col">
            <Inputs.InputBilingual
              control={control}
              errors={errors}
              nameTh="short_title_th"
              nameEn="short_title_en"
            />
          </div>
        </div>
        <div className="input_row lang_row">
          <div className="f_left_col">Short Description</div>
          <div className="f_right_col">
            <Inputs.InputBilingual
              control={control}
              errors={errors}
              nameTh="short_description_th"
              nameEn="short_description_en"
            />
          </div>
        </div>
        <div className="input_row lang_row">
          <div className="f_left_col">Name</div>
          <div className="f_right_col">
            <Inputs.InputBilingual
              control={control}
              errors={errors}
              nameTh="name_th"
              nameEn="name_en"
            />
          </div>
        </div>
        <div className="input_row lang_row">
          <div className="f_left_col">Description</div>
          <div className="f_right_col">
            <Inputs.InputBilingual
              control={control}
              errors={errors}
              nameTh="description_th"
              nameEn="description_en"
              isWysiwyg
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Start Date</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  placeholder={"Start Date"}
                  errors={errors.start_date?.message}
                  showYearDropdown
                />
              )}
              name="start_date"
              defaultValue={new Date()}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">End Date</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  placeholder={"End Date"}
                  errors={errors.end_date?.message}
                  showYearDropdown
                />
              )}
              name="end_date"
              defaultValue={new Date()}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Picture</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.UploadImage
                  {...field}
                  theme_upload_image
                  isDelete
                  fieldName="img"
                  acceptType={"cover"}
                  scaleLabel="*** รูปขนาดกว้าง 720px สูง 720px"
                  errors={errors.img_file?.message}
                />
              )}
              name="img_file"
              defaultValue={[]}
            />
          </div>
        </div>

        <div className="input_row">
          <div className="f_left_col">Document Label</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.TextField
                  {...field}
                  errors={errors.document_name?.message}
                />
              )}
              name="document_name"
              defaultValue=""
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Document upload</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.UploadImage
                  {...field}
                  theme_upload_image
                  isDelete
                  fieldName="document"
                  acceptType={"pdf"}
                  scaleLabel="*** PDF only"
                  errors={errors.document_file?.message}
                />
              )}
              name="document_file"
              defaultValue={[]}
            />
          </div>
        </div>

        <div className="input_row">
          <div className="f_left_col">Picture2</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.UploadImage
                  {...field}
                  isDelete
                  fieldName="img2"
                  theme_upload_image
                  acceptType={"cover"}
                  scaleLabel="*** รูปขนาดกว้าง 720px สูง 720px"
                  errors={errors.img_file?.message}
                />
              )}
              name="img_file2"
              defaultValue={[]}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Start date register</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  placeholder={"Registration Start date"}
                  errors={errors.registration_start_date?.message}
                  showYearDropdown
                />
              )}
              name="registration_start_date"
              // defaultValue={new Date()}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Start Time</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="HH:mm"
                  placeholder={"Start time"}
                  errors={errors.registration_start_time?.message}
                  showYearDropdown
                />
              )}
              name="registration_start_time"
              // defaultValue={new Date()}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">End date register</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  placeholder={"Registration End date"}
                  errors={errors.registration_end_date?.message}
                  showYearDropdown
                />
              )}
              name="registration_end_date"
              // defaultValue={new Date()}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">End Time</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="HH:mm"
                  placeholder={"End time"}
                  errors={errors.registration_end_time?.message}
                  showYearDropdown
                />
              )}
              name="registration_end_time"
              // defaultValue={new Date()}
            />
          </div>
        </div>
        {/* <div className="input_row">
          <div className="f_left_col">Last date register</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.DateTime
                  {...field}
                  placeholder={"Last date"}
                  errors={errors.last_date?.message}
                  showYearDropdown
                />
              )}
              name="last_date"
              // defaultValue={new Date()}
            />
          </div>
        </div> */}
        <div className="line_horizontal" />
        <div className="input_row">
          <div className="f_left_col">Certificate system</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_certificate?.message}
                />
              )}
              name="is_certificate"
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Create ID QR code</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_qrcode?.message}
                />
              )}
              name="is_qrcode"
            />
          </div>
        </div>
        <div className="line_horizontal" />
        <div className="input_row">
          <div className="f_left_col">One time popup</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  disabled={true}
                  errors={errors.is_popup_activate?.message}
                />
              )}
              name="is_popup_activate"
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">One time Notification</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  disabled={true}
                  errors={errors.is_notification_activate?.message}
                />
              )}
              name="is_notification_activate"
              defaultValue={false}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">* Send AUTO Email *</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_send_email?.message}
                />
              )}
              name="is_send_email"
              defaultValue={true}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">* Edit Request Active from customer *</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_edit_request_active?.message}
                />
              )}
              name="is_edit_request_active"
              defaultValue={false}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">Active</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_active?.message}
                />
              )}
              name="is_active"
              defaultValue={false}
            />
          </div>
        </div>
        <div className="input_row">
          <div className="f_left_col">PIN/Priority</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_active?.message}
                />
              )}
              name="is_pin"
              defaultValue={false}
            />
          </div>
        </div>
        <div className="line_horizontal" />
        <div className="input_row mb_100">
          <div className="f_left_col">Question Form</div>
          <div className="f_right_col">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.InputSwitch
                  {...field}
                  errors={errors.is_condition?.message}
                />
              )}
              name="is_condition"
              defaultValue={false}
            />
          </div>
        </div>
        {watchIsCondition === true && (
          <div className="page_block_container">
            {fields.map((item, index) => (
              <div key={item.id} className="part_block">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      hidden
                      options={[
                        {
                          label: "ฟอร์มสมัครแข่งพิเศษ สมัครได้หลายคน",
                          value: "1",
                        },
                      ]}
                      errors={errors.type?.message}
                      disabled={id !== "create"}
                    />
                  )}
                  name={`question_list.${index}.page`}
                  defaultValue={index + 1}
                />
                <div className="pb_header_block">
                  <div className="pb_page_label">Part {index + 1}</div>
                  <div
                    className="btn_delete_lv1"
                    onClick={() => {
                      AlertControl.show({
                        title: "ยืนยันการลบ",
                        description: "คุณต้องการจะลบใช่หรือไม่",
                        btnLabel1: "ยกเลิก ",
                        btnLabel2: "ยืนยัน",
                        onEvent2: async () => {
                          onDeleteQuestion && onDeleteQuestion("page", item);
                          remove(index);
                        },
                      });
                    }}
                  >
                    <MdDelete fontSize={25} color={"red"} />
                  </div>
                </div>
                <div className="pb_body_lv1_block">
                  <div className="pt_input_wrap">
                    <Controller
                      render={({ field }) => (
                        <Inputs.TextField
                          {...field}
                          label="Title"
                          errors={errors.type?.message}
                        />
                      )}
                      name={`question_list.${index}.title`}
                      control={control}
                    />
                  </div>
                  <div className="pt_input_wrap">
                    <Controller
                      render={({ field }) => (
                        <Inputs.TextField
                          {...field}
                          label="Description"
                          errors={errors.type?.message}
                        />
                      )}
                      name={`question_list.${index}.desc`}
                      control={control}
                    />
                  </div>
                  <div className="pt_input_wrap">
                    <Controller
                      render={({ field }) => (
                        <Inputs.TextField
                          {...field}
                          type="number"
                          label="Jump to part"
                          errors={errors.type?.message}
                        />
                      )}
                      name={`question_list.${index}.jump_to_part`}
                      control={control}
                    />
                  </div>
                </div>
                <div className="pb_question_lv2_block">
                  <QuestionForm
                    nestIndex={index}
                    pdpaOptions={pdpaOptions}
                    watchQuestionList={watchQuestionList}
                    dataItem={item}
                    onDeleteQuestion={onDeleteQuestion}
                    {...{ control, errors }}
                  />
                </div>
              </div>
            ))}
            <button
              type="button"
              className="btn_add_lv1"
              onClick={() => append()}
            >
              + Add more part
            </button>
          </div>
        )}
        {permission && (
          <div className="action_row">
            <div className="w120">
              <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
            </div>
            {id !== "create" &&
              permission.is_delete &&
              initialValues.is_edit && (
                <div className="w120">
                  <Buttons.BgStandard
                    theme_red
                    label="Delete"
                    onClick={onDelete}
                  />
                </div>
              )}
            {id !== "create" && permission.is_update ? (
              <>
                {!initialValues.is_popup_activate && (
                  <div className="w120">
                    <Buttons.BgStandard
                      theme_green
                      label="Sent popup"
                      onClick={onSent}
                    />
                  </div>
                )}
                {/* {initialValues.is_edit && ( */}
                <div className="w120">
                  <Buttons.BgStandard type="submit" label="Update" />
                </div>
                {/* )} */}
              </>
            ) : (
              permission.is_create && (
                <div className="w120">
                  <Buttons.BgStandard type="submit" label="Save" />
                </div>
              )
            )}
            {initialValues && (
              <div className="w120">
                <a
                  href={`${process.env.REACT_APP_DOMAIN}/activity-form/admin/preview/${initialValues._id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Buttons.BgStandard
                    theme_purple
                    type="button"
                    label="Preview"
                  />
                </a>
              </div>
            )}
          </div>
        )}
      </form>
    </ActivitySpecialFormStyled>
  );
};

ActivitySpecialForm.propTypes = {};

export default ActivitySpecialForm;
